module.exports = __webpack_public_path__ + "static/media/shop01_blank.fe0711e2.png";